import { render } from "./ReportElement.vue?vue&type=template&id=4d8896cf&scoped=true"
import script from "./ReportElement.vue?vue&type=script&lang=js"
export * from "./ReportElement.vue?vue&type=script&lang=js"

import "./ReportElement.vue?vue&type=style&index=0&id=4d8896cf&lang=scss&scoped=true"
import "./ReportElement.vue?vue&type=style&index=1&id=4d8896cf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8896cf"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn,QDialog,QCard,QCardSection,QSpace,QIcon});qInstall(script, 'directives', {ClosePopup});
